"use client";

import { sendGTMEvent } from "@next/third-parties/google";
import { GtmEvents } from "@yardzen/next-client-util";
import { useSession } from "next-auth/react";
import { useEffect } from "react";

/**
 * PageViewTracker component that sends GTM events with user authentication state
 * on every page/route change. This allows GTM to track which pages are visited
 * by authenticated vs. anonymous users.
 */
export function PageViewTracker() {
  const { data: session, status } = useSession();

  useEffect(() => {
    // Only send the event after session status is determined
    if (status === "loading") {
      return;
    }

    const userId =
      status === "authenticated" ? (session?.user as any)?.id : null;

    try {
      sendGTMEvent({
        event: GtmEvents.AUTH_STATE_CHANGE,
        user_id: userId,
      });
    } catch (error) {
      console.error("Failed to send GTM page view event", error);
    }
  }, [session, status]);

  return null;
}
